// import components
import { Box, Divider, styled } from '@mui/material';
import { Icon } from '@sdb/planning-ui';

/**
 * The heading row: the entity's symbol and name, then the rule running out to the edge.
 *
 * It carries its own space above, on top of the gap the stack gives every child. That extra room is what
 * separates the two tiers: the activity filter above narrows every view, everything from here down belongs
 * to one entity. Set on the heading rather than on the fields, so the rule travels with the section it
 * names instead of drifting up towards the filter it does not belong to.
 */
export const HeadingRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginTop: theme.spacing(1.5)
}));

/** The entity's own symbol, in its own colour — the same pairing the grid and the toolbar symbols use. */
export const HeadingIcon = styled(Icon, {
  shouldForwardProp: (prop) => prop !== 'entityColor'
})<{ entityColor?: string }>(({ entityColor }) => ({
  color: entityColor
}));

/**
 * The rule filling the row after the entity's name. It separates the fields below from the activity filter
 * above without boxing them in, and reading as part of the heading is what ties it to this entity rather
 * than looking like a line between two equal halves of the popover.
 */
export const HeadingRule = styled(Divider)({
  flexGrow: 1
});
